import { render, staticRenderFns } from "./DependentTable.vue?vue&type=template&id=57ce1f48&scoped=true"
import script from "./DependentTable.vue?vue&type=script&lang=js"
export * from "./DependentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce1f48",
  null
  
)

export default component.exports